import axios from "axios";
import config from "@/router/globalConfig";
export default {
    getFeedbackType(_data) {
        return axios.get(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/GetFeedBackType', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data
        });
    },
    getQuestion(_data) {
        return axios.post(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/GetQuestion', _data, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    getAnswer(_data) {
        return axios.post(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/GetAnswer', _data, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    getQuestionAnswerMap(_data) {
        return axios.post(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/GetQuestionAnswerMap', _data, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    SaveFeedBack(_data) {
        return axios.post(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/SaveFeedBackData', _data, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    GetCandidateFacultySubject(_data) {
        return axios.get(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/GetCandidateFacultySubject', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data
        });
    },
    SaveShortCourseFeedbackNew(_data) {
        return axios.post(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/SaveShortCourseFeedbackNew', _data, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    GetSHTFeedbackCommentsForLowRating(_data) {
        return axios.get(config.WEB_API_PATH + 'ShortCourseFeedBack/v1/GetSHTFeedbackCommentsForLowRating', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/ShortCourseFeedBackJS.js